import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import {
  pure,
  branch,
  compose,
  mapProps,
  withState,
  lifecycle,
  withHandlers,
  renderNothing,
  renderComponent,
} from 'recompose';

import {
  getCurrentUserId,
  checkIfCurrentUserSuperAdmin,
  checkIfCurrentUserSalesAgent,
} from '../../utils';
import { MainLayoutComponent } from './component';
import { withOrganizationSettings } from '../common';
import { ErrorPage } from '../../components/error-page';
import { redirectTo } from '../../api/utils/react-utils';
import { ROUTES, SUPER_ADMIN_ROUTES } from '../../routes';
import { handleUpdateProfile } from '../../redux/thunk/profile-settings';
import { updateProfileEndRequest } from '../../redux/actions/profile-settings';


const mapStateToProps = ({
  router: { route },
  auth: { isAuthorized },
  initialLoad,
  users: { items },
}) => ({
  route,
  isAuthorized,
  initialLoad,
  isUserSuperAdmin: checkIfCurrentUserSuperAdmin(items),
  isUserSalesAgent: checkIfCurrentUserSalesAgent(items),
  // User's last menu collapse status
  menuCollapseStatus: R.pathOr(false, [getCurrentUserId(), 'isMenuCollapsed'], items),
});

const mapDispatchToProps = ({
  handleUpdateProfile, updateProfileEndRequest,
});


export default compose(
  withOrganizationSettings,
  connect(mapStateToProps, mapDispatchToProps),
  withState('isOpenMobile', 'setIsOpenMobile', false),
  withState('isMenuCollapsed', 'setIsMenuCollapsed', false),
  withHandlers({
    handleChangeIsMenuCollapsed: actions => (isMenuCollapsed) => {
      const data = new FormData();

      data.append('isMenuCollapsed', isMenuCollapsed);

      actions.setIsMenuCollapsed(isMenuCollapsed);

      setTimeout(() =>
        actions.handleUpdateProfile(data)
          .catch((e) => {
            console.error(e);
          })
          .then(() => {
            actions.updateProfileEndRequest();
          }), 300);
    },
  }),
  lifecycle({
    componentDidMount() {
      const { menuCollapseStatus, isMenuCollapsed } = this.props;

      if (!R.equals(menuCollapseStatus, isMenuCollapsed)) {
        this.props.setIsMenuCollapsed(menuCollapseStatus);
      }
    },
    componentDidUpdate(prevProps) {
      const { menuCollapseStatus } = this.props;

      if (!R.equals(prevProps.menuCollapseStatus, menuCollapseStatus)) {
        this.props.setIsMenuCollapsed(menuCollapseStatus);
      }
    },
  }),
  branch(R.prop('initialLoad'), renderNothing),
  branch(R.propEq('route', ROUTES.EDIT_USER_DATA), renderNothing),
  branch(
    R.propEq('route', ROUTES.INVITE_USER),
    renderNothing,
    branch(R.complement(R.prop('isAuthorized')), redirectTo(ROUTES.SIGN_IN)),
  ),
  branch(R.propEq('route', ROUTES.SIGN_IN), renderNothing),
  branch(R.propEq('route', ROUTES.HOME), redirectTo(ROUTES.OVERVIEW)),
  branch(
    props => R.contains(R.prop('route', props), SUPER_ADMIN_ROUTES),
    branch(R.complement(R.prop('isUserSuperAdmin')), renderComponent(() => (
      <ErrorPage
        code={400}
        title="Bad Request"
        description="You don’t have permission to visit this page. Press Home to return to the Overview page."
      />
    ))),
  ),
  branch(
    R.propEq('route', ROUTES.STATISTICS),
    branch(R.prop('isUserSalesAgent'), renderComponent(() => (
      <ErrorPage
        code={400}
        title="Bad Request"
        description="You don’t have permission to visit this page. Press Home to return to the Overview page."
      />
    ))),
  ),
  branch(R.complement(R.prop('route')), redirectTo(ROUTES.OVERVIEW)),
  mapProps(R.omit(['setIsMenuCollapsed', 'handleUpdateProfile', 'updateProfileEndRequest',
    'menuCollapseStatus', 'isAuthorized', 'initialLoad'])),
  pure,
)(MainLayoutComponent);



// WEBPACK FOOTER //
// ./src/layouts/main/container.js